import { ApiCredentialExpiryDuration } from '../../enums/api-credentials/api-credential-expiry-duration.enum';
import { ApiCredentialScope } from '../../enums/api-credentials/api-credential-scope.enum';

export const API_CREDENTIAL_SCOPES_ORDERED: readonly ApiCredentialScope[] = [
  ApiCredentialScope.OrdersRead,
  ApiCredentialScope.OrdersCreate,
  ApiCredentialScope.OrdersCancel,
  ApiCredentialScope.WebhooksManage,
];

export const API_CREDENTIAL_EXPIRY_DURATIONS_ORDERED: readonly ApiCredentialExpiryDuration[] = [
  ApiCredentialExpiryDuration.OneMonth,
  ApiCredentialExpiryDuration.ThreeMonths,
  ApiCredentialExpiryDuration.SixMonths,
  ApiCredentialExpiryDuration.OneYear,
];
